import React, { useEffect } from 'react';

export default function SEO({ 
    title = 'Host-it! | Party Planning Made Simple', 
    description = 'The ultimate marketplace for party rentals, event spaces, vendors, and professional planning tools.', 
    keywords = 'party rentals, event spaces, wedding planner, vendor marketplace, party supplies',
    image = 'https://hostit.com/default-og-image.jpg', // Replace with your actual default OG image
    url = 'https://hostit.com'
}) {
    useEffect(() => {
        // 1. Update Document Title
        document.title = title;

        // Helper function to set or update meta tags safely
        const setMetaTag = (attr, key, content) => {
            if (!content) return;
            let element = document.querySelector(`meta[${attr}="${key}"]`);
            if (!element) {
                element = document.createElement('meta');
                element.setAttribute(attr, key);
                document.head.appendChild(element);
            }
            element.setAttribute('content', content);
        };

        // 2. Standard Meta Tags
        setMetaTag('name', 'description', description);
        setMetaTag('name', 'keywords', keywords);

        // 3. Open Graph (Facebook/LinkedIn) Meta Tags
        setMetaTag('property', 'og:title', title);
        setMetaTag('property', 'og:description', description);
        setMetaTag('property', 'og:image', image);
        setMetaTag('property', 'og:url', url);
        setMetaTag('property', 'og:type', 'website');

        // 4. Twitter Card Meta Tags
        setMetaTag('name', 'twitter:card', 'summary_large_image');
        setMetaTag('name', 'twitter:title', title);
        setMetaTag('name', 'twitter:description', description);
        setMetaTag('name', 'twitter:image', image);

        // Cleanup isn't strictly necessary here as we overwrite them on the next page load,
        // but if you unmount the app entirely, it's good practice.
    }, [title, description, keywords, image, url]);

    // This component doesn't render any visible UI
    return null;
}